// src/pages/admin/MarketingPage.js
import React from "react";

const MarketingPage = () => {
  return (
    <main className="flex-1 p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Marketing</h1>
      <p className="text-gray-600 mb-6">
        Manage your campaigns, contact lists, and ad platforms.
      </p>

      <div className="bg-white p-6 rounded-xl shadow">
        <ul className="space-y-2 text-gray-700 text-sm list-disc list-inside">
          <li>Email Campaign Builder</li>
          <li>Google Ads Integration</li>
          <li>Import & Manage Contact Lists</li>
          <li>Track Campaign Performance</li>
        </ul>
      </div>
    </main>
  );
};

export default MarketingPage;
